
import { connect } from 'react-redux';

import { setMapPoints } from '../actions/Map';
import { getTratDetail } from '../actions/TratDetail';
import TratDetailPage from '../components/TratDetailPage';

function mapDispatchToProps() {
    return {
        getTratDetail,
        setMapPoints
    };
}

function mapStateToProps(state, ownProps) {
    return {
        tratDetail: state.tratDetail,
        requiredId: ownProps.match.params.id
    };
}

export default connect(mapStateToProps, mapDispatchToProps())(TratDetailPage);
